<lg-quick-settings-menu
    [icon]="_icon"
    [definition]="_definition"
    [iconDefinitions]="_iconDefinitions"
    [selectedItems]="_selectedMenuItem ? [_selectedMenuItem] : []"
    [compact]="true"
    [focusEnabled]="true"
>
</lg-quick-settings-menu>
